import { Component, OnInit, EventEmitter, Output, Host } from '@angular/core';
import { GISPolyline, ConfigurationComponent, PolylineConfig } from '../models/geometry.model';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-polyline-configuration',
    templateUrl: './polyline-configuration.component.html',
    styleUrls: ['./polyline-configuration.component.scss'],
    standalone: false
})
export class PolylineConfigurationComponent implements OnInit, ConfigurationComponent<PolylineConfig> {
    model: PolylineConfig;

    @Output('modelChange')
    saveChange: Observable<any> = new EventEmitter();

    constructor(
    ) { }

    ngOnInit() { 
        if (!this.model.mappings)
            this.model.mappings = [{ xContextLocation: null, yContextLocation: null }];

    }

    addPoint() {
        this.model.mappings.push({ xContextLocation: null, yContextLocation: null });
    }

    save() {
        (this.saveChange as EventEmitter<any>).emit();
    }
}
